import { render, staticRenderFns } from "./ProductFormComponent.vue?vue&type=template&id=d0b080da&scoped=true&"
import script from "./ProductFormComponent.vue?vue&type=script&lang=js&"
export * from "./ProductFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductFormComponent.vue?vue&type=style&index=0&id=d0b080da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b080da",
  null
  
)

export default component.exports